// src/sync/initProjectSync.ts

/**
 * Project Sync Bootstrap - wires the real cloud and local sides into the engine.
 *
 * Call once during app start (client only). Idempotent: repeated calls are a
 * no-op. After this runs, cloudSync.attemptSync() reaches real Supabase
 * (project_sync_records) and applies pulls through the project store.
 *
 * No-op on the server (no project store, no browser Supabase session).
 */

import { cloudSync } from "@/sync/cloudSyncEngine";
import { createSupabaseSyncAdapter } from "@/sync/supabaseSyncAdapter";
import { createProjectStoreSyncProvider } from "@/sync/projectStoreSyncProvider";
import { isSupabaseConfigured } from "@/integrations/supabase/client";
import { logger } from "@/system/logger";

let initialized = false;

export function initProjectSync(opts: { autoSync?: boolean } = {}): boolean {
  if (initialized) return true;
  if (typeof window === "undefined") return false;       // client-only
  if (!isSupabaseConfigured()) {
    logger.info("[initProjectSync] Supabase not configured - project sync stays offline");
    return false;
  }

  cloudSync.configure({
    remote: createSupabaseSyncAdapter(),
    local:  createProjectStoreSyncProvider(),
  });

  if (opts.autoSync) cloudSync.enableAutoSync();

  initialized = true;
  logger.info("[initProjectSync] Project-level cloud sync wired");
  return true;
}

/** Test/teardown helper: allow re-initialization. */
export function _resetProjectSyncForTest(): void {
  initialized = false;
}
